import slick from 'slick-carousel';

window.Specs = function() {

    const slickLoaded = false;

    const startSlick = () => {
        if(!this.slickLoaded) {
            $('.slide-info').slick({
                asNavFor: '.slider-nav',
                infinite: false,
                fade: true,
                arrows: false,
            });
            $('.slider-nav').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.slide-info',
                focusOnSelect: true,
                infinite: false,
                nextArrow: `<a href="#" class="slick-next">
                        <img src="/images/arrow-right.svg" alt="" />
                    </a>`,
                prevArrow: `<a href="#" class="slick-prev">
                        <img src="/images/arrow-right.svg" alt="" />
                    </a>`
            });
            const self = this;
            $('a[data-toggle=collapse]').on('click', function(){
                if(self.slickLoaded) {
                    $('.slide-info').slick('refresh');
                }
            });
            this.slickLoaded = true;
        }
    };

    const loadConfig = () => {
        if($(window).width() < 992) {
            startSlick();
        }else {
            if(this.slickLoaded) {
                $('.slide-info').slick('unslick');
                $('.slider-nav').slick('unslick');
                $('a[data-toggle=collapse]').on('click', function(){

                });
                this.slickLoaded = false;
            }
        }
    };

    loadConfig();

    $(window).on('resize', function(){
        loadConfig();
    });

    window.onscroll = function() {stickyCarTab()};

    // Get the navbar
    var navbar = document.querySelector(".car-tabs");

    // Get the offset position of the navbar
    var stickyTab = navbar.offsetTop;

    // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function stickyCarTab() {
        if (window.pageYOffset >= stickyTab) {
            navbar.classList.add("stickyCar")
        } else {
            navbar.classList.remove("stickyCar");
        }
    }

};